import React, { useState } from "react";
import {
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Input,
  Label,
  Button,
} from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { formatDate } from "../../Utilities/dateUtils";
import { UpdateLicenseCustomer } from "../../actions/superUserMutations";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GetLicenseManagementCustomers } from "../../actions/superUserQueries";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

function LicMgtCustomerCard({ customer, handleUpdateData }) {
  const intl = useIntl();
  const [editMode, setEditMode] = useState(false);
  const [updatedCustomer, setUpdatedCustomer] = useState({ ...customer });
  const handleUpdateCustomer = useMutation({ mutationFn: UpdateLicenseCustomer });
  const queryClient = useQueryClient();
  const licenseCustomers = GetLicenseManagementCustomers();

  const postUpdateCustomer = () => {
    if (updatedCustomer.customer.url.length > 3) {
      handleUpdateCustomer.mutate(
        {
          fortnoxNumber: updatedCustomer.customer.fortNoxNumber,
          url: updatedCustomer.customer.url,
          contactName:
            updatedCustomer.customer.contactName === null
              ? ""
              : updatedCustomer.customer.contactName,
          contactMail:
            updatedCustomer.customer.contactMail === null
              ? ""
              : updatedCustomer.customer.contactMail,
        },
        {
          onSuccess: (data) => {
            if (data && data.status > 199 && data.status < 300) {
              toast.success(intl.formatMessage({ id: "CustomerUpdated" }));
              let tempCustomerData = [...licenseCustomers.data];
              tempCustomerData.find(
                (cust) => cust.customer.id === customer.customer.id
              ).customer.url = data.data.result.customer.url;
              tempCustomerData.find(
                (cust) => cust.customer.id === customer.customer.id
              ).customer.contactName = data.data.result.customer.contactName;
              tempCustomerData.find(
                (cust) => cust.customer.id === customer.customer.id
              ).customer.contactMail = data.data.result.customer.contactMail;
              queryClient.setQueryData(
                ["FetchLicenseManagementCustomers"],
                () => tempCustomerData
              );
              setEditMode(false);
              handleUpdateData();
            } else {
              let errorMessage = <FormattedMessage id="GeneralError" />;
              if (data?.response?.data) {
                errorMessage = formatServiceError(intl, data.response.data);
              }
              toast.warn(errorMessage);
            }
          },
        }
      );
    }
  };

  return (
    <Card style={{ width: "40%" }} className="mx-auto">
      <CardBody>
        <CardTitle>
          {customer.customer.name}
          <hr />
        </CardTitle>
        <Row className="mb-2">
          <Col>
            <Label className="me-2 mb-0" for="urlInput">
              <FormattedMessage id="Url" />:
            </Label>
            {editMode ? (
              <Input
                className="rounded h-100 py-0"
                style={{ width: "60%", display: "inline-block" }}
                name="urlInput"
                type="text"
                defaultValue={customer.customer.url}
                onBlur={(data) =>
                  setUpdatedCustomer({
                    ...updatedCustomer,
                    customer: {
                      ...updatedCustomer.customer,
                      url: data.target.value,
                    },
                  })
                }
              />
            ) : (
              <span name="urlInput">{customer.customer.url}</span>
            )}
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Label className="me-2 mb-0" for="contactNameInput">
              Kontaktperson:
            </Label>
            {editMode ? (
              <Input
                className="rounded h-100 py-0"
                style={{ width: "60%", display: "inline-block" }}
                name="contactNameInput"
                type="text"
                defaultValue={customer.customer.contactName}
                onBlur={(data) =>
                  setUpdatedCustomer({
                    ...updatedCustomer,
                    customer: {
                      ...updatedCustomer.customer,
                      contactName: data.target.value,
                    },
                  })
                }
              />
            ) : (
              <span name="contactNameInput">
                {customer.customer.contactName}
              </span>
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <Label className="me-2 mb-0" for="contactMailInput">
              Email:
            </Label>
            {editMode ? (
              <Input
                className="rounded h-100 py-0"
                style={{ width: "60%", display: "inline-block" }}
                name="contactMailInput"
                type="text"
                defaultValue={customer.customer.contactMail}
                onBlur={(data) =>
                  setUpdatedCustomer({
                    ...updatedCustomer,
                    customer: {
                      ...updatedCustomer.customer,
                      contactMail: data.target.value,
                    },
                  })
                }
              />
            ) : (
              <span name="urlInput">{customer.customer.contactMail}</span>
            )}
          </Col>
        </Row>

        <Row>
          <Col className="lead">{customer.customer.address}</Col>
        </Row>
        <Row>
          <Col className="lead">
            {customer.customer.zipCode} {customer.customer.city}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <FormattedMessage id="Created" />:{" "}
            {formatDate(customer.customer.created, "P")}
          </Col>
        </Row>
        <Row>
          <Col>
            {editMode ? (
              <>
                <Button
                  outline
                  color="primary"
                  className="m-2 float-end"
                  onClick={() => postUpdateCustomer()}
                >
                  <FormattedMessage id="Save" />
                </Button>
                <Button
                  color="secondary"
                  outline
                  className="m-2 float-end"
                  onClick={() => setEditMode(false)}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              </>
            ) : (
              <>
                <Button
                  outline
                  color="primary"
                  className="m-2 float-end"
                  onClick={() => setEditMode(true)}
                >
                  <FormattedMessage id="Edit" />
                </Button>
              </>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default LicMgtCustomerCard;
